module.exports = __webpack_public_path__ + "static/media/info-routing-num.38dbe535.png";